import {
  PROJECT_ADD_ERROR,
  PROJECT_ADD_LOADING,
  PROJECT_ADD_SUCCESS,
  PROJECT_CLOSE_ERROR,
  PROJECT_CLOSE_LOADING,
  PROJECT_CLOSE_SUCCESS,
  PROJECT_DELETE_ERROR,
  PROJECT_DELETE_SUCCESS,
  PROJECT_FETCH_ERROR,
  PROJECT_FETCH_LOADING,
  PROJECT_FETCH_SUCCESS,
  PROJECT_GET_ERROR,
  PROJECT_GET_LOADING,
  PROJECT_GET_SUCCESS,
  PROJECT_UPDATE_ERROR,
  PROJECT_UPDATE_LOADING,
  PROJECT_UPDATE_SUCCESS,
  TECH_STACK_FETCH_ERROR,
  TECH_STACK_FETCH_LOADING,
  TECH_STACK_FETCH_SUCCESS,
} from "src/redux/types";
import { addProject, closeProject, deleteProject, fetchTechStack, getAllProjects, getProjectById, updateProject } from "../api";
import { Constant } from "../lib/Constants";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

function* techStackFetch() {
  yield put({
    type: TECH_STACK_FETCH_LOADING,
    payload: true,
  });
  try {
    let res = yield call(fetchTechStack);
    let response = res.response.data;
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: TECH_STACK_FETCH_SUCCESS,
        payload: response.result,
      });
    } else {
      yield put({
        type: TECH_STACK_FETCH_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}

function* projectFetch(action) {
  yield put({
    type: PROJECT_FETCH_LOADING,
    payload: true,
  });
  try {
    let res = yield call(getAllProjects);
    let response = res.response.data;
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: PROJECT_FETCH_SUCCESS,
        payload: response.result,
      });
    } else {
      yield put({
        type: PROJECT_FETCH_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}

function* projectDelete(action) {
  try {
    let res = yield call(deleteProject, action.payload);
    let response = res.response.data;
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: PROJECT_DELETE_SUCCESS,
        payload: response.message,
      });
    } else {
      yield put({
        type: PROJECT_DELETE_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}

function* projectAdd(action) {
  yield put({
    type: PROJECT_ADD_LOADING,
    payload: true,
  });
  try {
    let res = yield call(addProject, action.payload);
    let response = res.response.data;
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: PROJECT_ADD_SUCCESS,
        payload: response.message,
      });
    } else {      
      yield put({
        type: PROJECT_ADD_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}

function* projectUpdate(action) {
  yield put({
    type: PROJECT_UPDATE_LOADING,
    payload: true,
  });
  try {
    let res = yield call(updateProject, action.payload);
    let response = res.response.data;
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: PROJECT_UPDATE_SUCCESS,
        payload: response.message,
      });
    } else {
      yield put({
        type: PROJECT_UPDATE_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}
function* projectGet(action) {
    yield put({
      type: PROJECT_GET_LOADING,
      payload: true,
    });
    try {
      let res = yield call(getProjectById, action.payload);
      let response = res.response.data;
      if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
        yield put({
          type: PROJECT_GET_SUCCESS,
          payload: response.result,
        });
      } else {        
        yield put({
          type: PROJECT_GET_ERROR,
          payload: response.message,
        });
      }
    } catch (error) {
      // console.log(error);
      // yield put({
      //   type: LEAVE_GET_ERROR,
      //   payload: error.toString(),
      // });
    }
  }
function* projectClose(action) {
    yield put({
      type: PROJECT_CLOSE_LOADING,
      payload: true,
    });
    try {
      let res = yield call(closeProject, action.payload);
      let response = res.response.data;
      if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
        yield put({
          type: PROJECT_CLOSE_SUCCESS,
          payload: response.message,
        });
      } else {
        yield put({
          type: PROJECT_CLOSE_ERROR,
          payload: response.message,
        });
      }
    } catch (error) {
      // console.log(error);
      // yield put({
      //   type: LEAVE_GET_ERROR,
      //   payload: error.toString(),
      // });
    }
  }
export function* projectSaga() {
  yield takeEvery("TECH_STACK_FETCH_ACTION", techStackFetch);
  yield takeLatest("PROJECT_FETCH_ACTION", projectFetch);
  yield takeLatest("PROJECT_DELETE_ACTION", projectDelete);
  yield takeLatest("PROJECT_UPDATE_ACTION", projectUpdate);
  yield takeLatest("PROJECT_ADD_ACTION", projectAdd);
  yield takeLatest("PROJECT_GET_ACTION",projectGet);
  yield takeLatest("PROJECT_CLOSE_ACTION",projectClose);
}
